import { Directive, Input } from "@angular/core";
import {
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";

@Directive({
  selector: "[appUniqueEmail]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: UniqueEmailValidatorDirective,
      multi: true,
    },
  ],
})
export class UniqueEmailValidatorDirective implements Validator {
  @Input("appUniqueEmail") emailList: string[] = [];

  validate(control: AbstractControl): ValidationErrors | null {
    const email = control.value;
    // console.log(
    //   "this.emailList.includes(email)-->",
    //   this.emailList.includes(email)
    // );
    // console.log("email-->", email);

    if (this.emailList.includes(email)) {
      return { uniqueEmail: true };
    }
    return null;
  }
}
